import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import LearningModuleStepsScreen from '../components/LearningModuleStepsScreen';
import {
  loadModuleLearningSteps,
  createModuleView,
  patchModuleView,
} from '../../../../../state/modules/learnings/actions';

import { loadModule } from '../../../../../state/modules/learnings/actions';

const defaultLimit = 10;
const defaultOrder = 'order.asc';

const mapStateToProps = (state, ownProps) => {
  const activeId = state.careGuides.get('activeId');
  const moduleId = ownProps.match.params.moduleId ?? null;

  const learningModule = moduleId
    ? denormalize(
        state.entities.getIn(['learningModules', moduleId]),
        schema.learningModule,
        state.entities.toJS()
      )
    : null;

  // merge results for all modules
  const results = [].concat.apply(
    [],
    Object.entries(
      state.learnings.getIn(
        [
          'moduleLearningSteps',
          activeId,
          moduleId,
          'pages',
          defaultOrder,
          defaultLimit,
        ],
        {}
      )
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['learningModuleLearningSteps', x]),
              schema.learningModuleLearningStep,
              state.entities.toJS()
            ),
          };
        })
      : [];

  const moduleStepIdActive = list.filter((x) => x.state === 2).map((x) => x.id);

  return {
    moduleStepIdActive:
      moduleStepIdActive.length > 0
        ? moduleStepIdActive[0]
        : list.length > 0
        ? list[0].id
        : null,
    activeId,
    moduleId,
    learningModule,
    list,
    totalModuleLearningSteps: state.learnings.get('totalModuleLearningSteps'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (careGuideId, id, cb) => {
      dispatch(loadModule(careGuideId, id, cb));
    },
    createModuleView: (moduleId, cb) => {
      dispatch(createModuleView(moduleId, cb));
    },
    patch: (id, data, cb) => {
      dispatch(patchModuleView(id, data, cb));
    },
    loadSteps: (
      careGuideId,
      moduleId,
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      cb = function () {}
    ) => {
      dispatch(
        loadModuleLearningSteps(
          careGuideId,
          moduleId,
          page,
          limit,
          order,
          (success, total) => {
            if (success) {
              // loop over all pages to get all modules
              const pageCount = Math.ceil(total / limit);

              for (var i = 2; i <= pageCount; i++) {
                dispatch(
                  loadModuleLearningSteps(
                    careGuideId,
                    moduleId,
                    i,
                    limit,
                    order
                  )
                );
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const LearningModuleStepsScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningModuleStepsScreen);

export default LearningModuleStepsScreenContainer;
